<template>
    <v-card-title component="VoicesHeader">
        <div class="name">Voices</div>
        <div class="count">
            {{ count }} pc.
            <btn v-if="!getSearchIsVisible" :icon="'search'" size="iconBig" color="transparent" @click="showSearch" />
        </div>

        <div class="actions" :class="{ isVisible: getSearchIsVisible }">
            <div class="search">
                <v-text-field
                    ref="searchInput"
                    v-model="query"
                    dense
                    hide-details="true"
                    placeholder="Search"
                    @keyup.esc="resetSearch"
                    @blur="!query.length && resetSearch()"
                />
                <btn class="close" :icon="'close'" size="iconBig" color="transparent" @click="resetSearch" />
            </div>
        </div>
        <div class="emails" :class="{ isVisible: emails.return }">
            <div class="message">{{ emails.message }}</div>
            <btn
                size="icon"
                color="transparent"
                :icon="'alternate_email'"
                @click="getEmails"
                :state="emails.load ? 'load' : ''"
            ></btn>
        </div>
    </v-card-title>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import '@/utils/moveableDialog.js';
import _debounce from 'lodash/debounce';
import copy from 'copy-to-clipboard';

export default {
    name: 'VoicesHeader',

    props: {
        count: Number,
        required: true,
    },

    data() {
        return {
            query: '',
            emails: {
                load: false,
                return: false,
                message: '',
            },
        };
    },

    mounted() {
        this.queryUnwatch = this.$watch('query', _debounce(this.doSearch, 500));
    },

    beforeDestroy() {
        this.queryUnwatch();
    },

    methods: {
        ...mapActions(['loadActorsEmails']),
        ...mapMutations(['setSearchIsVisible']),

        showSearch() {
            this.setSearchIsVisible(true);
            setTimeout(() => {
                this.$refs.searchInput.focus();
            }, 300);
        },

        doSearch() {
            if (this.query.length >= 3) {
                this.$emit('search', this.query);
            }
        },

        resetSearch() {
            this.setSearchIsVisible(false);
            this.query = '';
            this.$emit('search', null);
        },

        async getEmails() {
            this.emails.load = true;
            try {
                const response = await this.loadActorsEmails();
                this.emails.load = false;
                this.emails.return = true;
                this.emails.message = 'Emails copied';
                copy(response.join(';'));
            } catch (e) {
                this.emails.message = 'Error occurred';
                throw e;
            } finally {
                setTimeout(() => {
                    this.emails.return = false;
                }, 2500);
            }
        },
    },

    computed: {
        ...mapGetters(['getSelectedCharacter', 'getProject', 'getSearchIsVisible']),
    },
};
</script>

<style lang="less">
@import '~@variables';

[component='VoicesHeader'] {
    padding: 6px 8px 6px 15px !important;
    height: 45px;
    max-height: 45px;
    .font;
    .flex-row;
    flex-wrap: nowrap;

    .count {
        font-size: 14px;
        white-space: nowrap;
        .flex-row;
        min-width: 54px;
    }

    button {
        &.close {
            margin-right: 3px;
        }
    }

    .actions {
        .flex-row;
        justify-content: flex-end;
        overflow: hidden;
        position: relative;
        width: 28px;
        transition: 0.3s;

        &.isVisible {
            width: 65%;
            .search {
                opacity: 1;
                pointer-events: all;
            }
        }

        .search {
            .flex-row;
            width: 100%;
            background-color: white;
            z-index: 4;
            padding-left: 5px;
            opacity: 0;
            pointer-events: none;
        }
    }

    .emails {
        .flex-row;
        justify-content: flex-end;
        position: absolute;
        right: 8px;
        width: 70%;

        &.isVisible {
            .message {
                width: 100%;
                flex: 1;
            }
        }

        .message {
            .flex-row;
            justify-content: flex-end;
            overflow: hidden;
            width: 0;
            background-color: white;
            z-index: 4;
            font-size: 13px;
            white-space: nowrap;
            transition: 0.3s;
            flex: 0;
        }
    }

    .name {
        margin-right: 15px;
        white-space: nowrap;
        flex: 1;
    }
}
</style>
